import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// إنشاء instance محسن للـ axios
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10 ثوانٍ بدلاً من الافتراضي
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': 'ar',
    'lang': 'ar',
  },
  // تحسينات الأداء
  maxRedirects: 3,
  maxContentLength: 50 * 1024 * 1024, // 50MB
  validateStatus: function (status) {
    return status >= 200 && status < 300; // قبول فقط 2xx
  },
});

// إضافة interceptor للطلبات
apiClient.interceptors.request.use(
  (config) => {
    // إضافة token إذا كان متوفراً
    const storeData = sessionStorage.getItem('storekhadamat');
    const adminData = sessionStorage.getItem('adminkhadamat');
    const doctorData = sessionStorage.getItem('doctorKhadamat');
    const clinicData = sessionStorage.getItem('clinicKhadamat');
    
    if (storeData) {
      try {
        const parsed = JSON.parse(storeData);
        if (parsed.token) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }
      } catch (error) {
      }
    } else if (adminData) {
      try {
        const parsed = JSON.parse(adminData);
        const token = parsed.data?.token?.access_token || parsed.data?.access_token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
      }
    } else if (doctorData) {
      try {
        const parsed = JSON.parse(doctorData);
        if (parsed.token) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }
      } catch (error) {
      }
    } else if (clinicData) {
      try {
        const parsed = JSON.parse(clinicData);
        if (parsed.token) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }
      } catch (error) {
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// إضافة interceptor للاستجابات
apiClient.interceptors.response.use(
  (response) => {
    // إرجاع البيانات مباشرة
    return response;
  },
  (error) => {
    // معالجة الأخطاء بشكل موحد
    if (error.response?.status === 401) {
      // إعادة توجيه للدخول
      sessionStorage.clear();
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

// دوال مساعدة للطلبات السريعة
export const apiGet = async (url, params = {}) => {
  try {
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiPost = async (url, data = {}) => {
  try {
    const response = await apiClient.post(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiPut = async (url, data = {}) => {
  try {
    const response = await apiClient.put(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiDelete = async (url) => {
  try {
    const response = await apiClient.delete(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// دالة للطلبات المتوازية
export const apiParallel = async (requests) => {
  try {
    const responses = await Promise.all(requests);
    return responses;
  } catch (error) {
    throw error;
  }
};

export default apiClient;
